import React from "react";
import styles from "./Styles.module.css";

const Navbar = () => {
  return (
    <div className={styles.navbarContainer}>
      <h3>Swachh Bharat Mission-Urban</h3>
    </div>
  );
};

export default Navbar;
